<div class="modal">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">
    <mat-icon class="back" (click)="gotoChoiceModal()">arrow_back_ios</mat-icon
    >选择您想了解的产品
  </div>
  <!-- <div class="input">
    <input
      type="text"
      placeholder="搜索您想要的产品"
      (keydown.enter)="onSearch()"
    />
    <mat-icon (click)="onSearch()">search</mat-icon>
  </div> -->
  <div class="detail" mat-dialog-content>
    <app-platform-tab-list-sversion></app-platform-tab-list-sversion>
  </div>
</div>
